export const CLASSFY = [
  { label: '公告', value: 0 },
  { label: '活动', value: 1 },
  { label: '攻略', value: 2 },
  { label: '更新日志', value: 3 },
  { label: 'Bug 反馈', value: 4 },
  { label: '建议收集', value: 5 },
  { label: '其他', value: 6 },
];
